$(() => {
  toggleNavTabsState();
});
function toggleNavTabsState() {
  const $dropdown = $(".js-stores-dropdown");
  const $dropdownLinks = $dropdown.find(".js-stores-dropdown-link");
  const $dropdownTitle = $dropdown.find(".js-stores-dropdown-title");
  $dropdownLinks.on("shown.bs.tab", (e) => {
    const $link = $(e.target);
    $dropdownLinks.removeClass("active");
    $link.addClass("active");
    $dropdownTitle.text($link.attr("title"));
  });
}
if (module.hot) { module.hot.accept(); }